import ProductMaster from './ProductMaster.vue';
import ProductMasterList from './views/productMasterList.vue';

export const productMasterRoutes = [
  {
    path: 'product-master',
    component: ProductMaster,
    children: [
      { path: '', component: ProductMasterList, name: 'product-master-list' }
    ]
  }
];
